// @ts-ignore - colord has module resolution issues in strict mode
import { colord } from "colord";

export const appTheme = {
	colors: {
		brand: "#3f7eab",
		secondary: "#2b2b2b",
		divider: "#bbb",
		dividerLight: "#DEDEDE",
		text: "#2b2b2b",
		textDimmed: "#999",
		secondaryBrand: colord("#fbe2cd").lighten(0.06).toHex(),
		success: "#4BB769",
		lightGreen: "#EDF8F0",
		darkGreen: "#3FB15F",
		destructive: "red",
		dark: "#333000",
		darker: "#333333",
		darkRed: "#C44747",
		lightRed: "#F5E0E0",
		darkGray: "#828282",
		lightYellow: "#ffdc40",
		green: "#29A54D",
		peach: "#EFF5B5",
		lightRose: "#FEDCDB",
		backgroundRed: "#FF0000",
		textDark: "#353535",
		textLight: "#FFFFFF",
	},
	font: {
		family: "Inter,sans-serif",
		small: "0.9rem",
		xSmall: "0.8rem",
		pLineHeight: 1.375,
	},
	buttons: {
		radius: 25,
	},

	login: {},
};

export type ThemeType = typeof appTheme;
